<dx-popup
  [showTitle]="true"
  [title]="dialogTitle()"
  [visible]="displayDialog()"
  (onHidden)="closeDialog()"
  [fullScreen]="true"
  [resizeEnabled]="true"
  [showCloseButton]="true">

  <dx-load-panel
    [visible]="avoirResource.isLoading()"
    [showPane]="true"
    [showIndicator]="true"
    message="Chargement...">
  </dx-load-panel>

  @if (avoirResource.value(); as avoir) {

    <table class="facture-info-table">
      <thead>
        <tr>
          <th>Statut</th>
          <th>Rapprochement</th>
          <th>Source</th>
          <th>Référence externe</th>
          <th>Numéro</th>
          <th>Date avoir</th>
          <th>Date saisie comptable</th>
          <th>Date création source</th>
          <th>Fournisseur</th>
          <th>Unité Production</th>
          @if (avoir.factureBloquante) { <th>Facture bloquante</th> }
          @if (avoir.documentNom) { <th>Document</th> }
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>{{ avoirStatutLabels[avoir.statut] ?? avoir.statut }}</td>
          <td>{{ rapprochementStatutLabels[avoir.rapprochementStatut] ?? avoir.rapprochementStatut }}</td>
          <td>{{ avoir.source }}</td>
          <td>{{ avoir.externalReference }}</td>
          <td>
            @if (avoir.url) {
              <a [href]="avoir.url" target="_blank" rel="noopener noreferrer">{{ avoir.numero }}</a>
            } @else {
              {{ avoir.numero }}
            }
          </td>
          <td>{{ avoir.dateFacture | date:'dd/MM/yyyy' }}</td>
          <td>{{ avoir.dateSaisieComptable | date:'dd/MM/yyyy' }}</td>
          <td>{{ avoir.dateCreationSource | date:'dd/MM/yyyy HH:mm' }}</td>
          <td>{{ avoir.fournisseurCode }}</td>
          <td>{{ avoir.siteExterneLibelle }}</td>
          @if (avoir.factureBloquante) { <td>Oui</td> }
          @if (avoir.documentNom) { <td>{{ avoir.documentNom }}</td> }
        </tr>
      </tbody>
    </table>

    <table class="facture-info-table">
      <thead>
        <tr>
          <th>Montant HT</th>
          <th>Montant TTC</th>
          @if (avoir.tva1Taux) { <th>TVA {{ avoir.tva1Taux }}%</th> }
          @if (avoir.tva2Taux) { <th>TVA {{ avoir.tva2Taux }}%</th> }
          @if (avoir.tva3Taux) { <th>TVA {{ avoir.tva3Taux }}%</th> }
          @if (avoir.tva4Taux) { <th>TVA {{ avoir.tva4Taux }}%</th> }
          @if (avoir.tva5Taux) { <th>TVA {{ avoir.tva5Taux }}%</th> }
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>{{ avoir.montantHT | number:'1.2-2' }} €</td>
          <td>{{ avoir.montantTTC | number:'1.2-2' }} €</td>
          @if (avoir.tva1Taux) { <td>{{ avoir.tva1Montant | number:'1.2-2' }} €</td> }
          @if (avoir.tva2Taux) { <td>{{ avoir.tva2Montant | number:'1.2-2' }} €</td> }
          @if (avoir.tva3Taux) { <td>{{ avoir.tva3Montant | number:'1.2-2' }} €</td> }
          @if (avoir.tva4Taux) { <td>{{ avoir.tva4Montant | number:'1.2-2' }} €</td> }
          @if (avoir.tva5Taux) { <td>{{ avoir.tva5Montant | number:'1.2-2' }} €</td> }
        </tr>
      </tbody>
    </table>

    @if (avoir.rapprochementList?.length) {
      <div class="rapprochement-section">
        <div class="rapprochement-title">Rapprochements</div>
        <dx-data-grid
          [dataSource]="avoir.rapprochementList"
          keyExpr="id"
          [showBorders]="true"
          [showRowLines]="true"
          [rowAlternationEnabled]="true"
          [allowColumnResizing]="true"
          columnResizingMode="widget">

          <dxi-column dataField="numeroBonLivraison" caption="N° Bon livraison"></dxi-column>
          <dxi-column caption="N° Avoir fournisseur" cellTemplate="avoirFournisseurTemplate"></dxi-column>
          <dxi-column dataField="montantHT" caption="Montant HT" dataType="number" [format]="{ type: 'currency', currency: 'EUR', precision: 2 }"></dxi-column>
          <dxi-column dataField="montantTTC" caption="Montant TTC" dataType="number" [format]="{ type: 'currency', currency: 'EUR', precision: 2 }"></dxi-column>
          @if (getRapprochementTvaTaux(avoir, 1); as taux) {
            <dxi-column dataField="tva1Montant" [caption]="'TVA ' + taux + '%'" dataType="number" [format]="{ type: 'currency', currency: 'EUR', precision: 2 }"></dxi-column>
          }
          @if (getRapprochementTvaTaux(avoir, 2); as taux) {
            <dxi-column dataField="tva2Montant" [caption]="'TVA ' + taux + '%'" dataType="number" [format]="{ type: 'currency', currency: 'EUR', precision: 2 }"></dxi-column>
          }
          @if (getRapprochementTvaTaux(avoir, 3); as taux) {
            <dxi-column dataField="tva3Montant" [caption]="'TVA ' + taux + '%'" dataType="number" [format]="{ type: 'currency', currency: 'EUR', precision: 2 }"></dxi-column>
          }
          @if (getRapprochementTvaTaux(avoir, 4); as taux) {
            <dxi-column dataField="tva4Montant" [caption]="'TVA ' + taux + '%'" dataType="number" [format]="{ type: 'currency', currency: 'EUR', precision: 2 }"></dxi-column>
          }
          @if (getRapprochementTvaTaux(avoir, 5); as taux) {
            <dxi-column dataField="tva5Montant" [caption]="'TVA ' + taux + '%'" dataType="number" [format]="{ type: 'currency', currency: 'EUR', precision: 2 }"></dxi-column>
          }

          <div *dxTemplate="let cell of 'avoirFournisseurTemplate'">
            {{ cell.row.data.avoirNumero }}
          </div>

          <dxo-summary>
            <dxi-total-item column="montantHT" summaryType="sum"
              [skipEmptyValues]="true" [valueFormat]="{ type: 'fixedPoint', precision: 2 }"
              displayFormat="{0} €">
            </dxi-total-item>
            <dxi-total-item column="montantTTC" summaryType="sum"
              [skipEmptyValues]="true" [valueFormat]="{ type: 'fixedPoint', precision: 2 }"
              displayFormat="{0} €">
            </dxi-total-item>
            <dxi-total-item column="tva1Montant" summaryType="sum"
              [skipEmptyValues]="true" [valueFormat]="{ type: 'fixedPoint', precision: 2 }"
              displayFormat="{0} €">
            </dxi-total-item>
            <dxi-total-item column="tva2Montant" summaryType="sum"
              [skipEmptyValues]="true" [valueFormat]="{ type: 'fixedPoint', precision: 2 }"
              displayFormat="{0} €">
            </dxi-total-item>
            <dxi-total-item column="tva3Montant" summaryType="sum"
              [skipEmptyValues]="true" [valueFormat]="{ type: 'fixedPoint', precision: 2 }"
              displayFormat="{0} €">
            </dxi-total-item>
            <dxi-total-item column="tva4Montant" summaryType="sum"
              [skipEmptyValues]="true" [valueFormat]="{ type: 'fixedPoint', precision: 2 }"
              displayFormat="{0} €">
            </dxi-total-item>
            <dxi-total-item column="tva5Montant" summaryType="sum"
              [skipEmptyValues]="true" [valueFormat]="{ type: 'fixedPoint', precision: 2 }"
              displayFormat="{0} €">
            </dxi-total-item>
          </dxo-summary>

          <dxo-scrolling mode="standard" [useNative]="true"></dxo-scrolling>
          <dxo-pager [visible]="false"></dxo-pager>
        </dx-data-grid>
      </div>
    }

    <div class="custom-button-container-right" style="margin-top: 12px;">
      @if (avoir.statut === AvoirExterneStatutEnum.A_TRAITER) {
        <yo-button
          iconClass="fas fa-ban"
          label="Abandonner"
          tooltip="Abandonner l'avoir externe"
          [theme]="ButtonThemeEnum.ERROR"
          (onClick)="abandonner()">
        </yo-button>
        <yo-button
          iconClass="fas fa-times"
          label="Refuser"
          tooltip="Refuser l'avoir externe"
          [theme]="ButtonThemeEnum.ERROR"
          (onClick)="refuser()">
        </yo-button>
      }
      @if (avoir.rapprochementStatut === RapprochementStatutEnum.ECART) {
        <yo-button
          iconClass="fas fa-check"
          label="Valider l'écart"
          tooltip="Valider l'écart de rapprochement"
          [theme]="ButtonThemeEnum.WARNING"
          (onClick)="validerEcart()">
        </yo-button>
      } @else if ((avoir.rapprochementStatut === RapprochementStatutEnum.RAPPROCHEMENT_OK || avoir.rapprochementStatut === RapprochementStatutEnum.ECART_VALIDE) && !avoir.factureBloquante && (avoir.statut !== AvoirExterneStatutEnum.VALIDEE_AUTOMATIQUEMENT && avoir.statut !== AvoirExterneStatutEnum.VALIDEE_MANUELLEMENT)) {
        <yo-button
          iconClass="fas fa-check"
          label="Valider le rapprochement"
          tooltip="Valider le rapprochement"
          [theme]="ButtonThemeEnum.VALIDATE"
          (onClick)="validerRapprochement()">
        </yo-button>
      }
    </div>
  }

</dx-popup>
